<script lang="ts" setup>
import { entraAuthService } from '@/services/auth/entra-auth-service';
import { hasPermission } from 'cesg-shared/dist/functions/auth/permission';
import {
  PermissionResource,
  PermissionType,
  UserRole,
} from 'cesg-shared/dist/models';
import { computed } from 'vue';
import ProjectOrganisationCesg from '../ProjectOrganisationCesg.vue';
import type {
  ProjectOrganisationCesgActionEvent,
  ProjectOrganisationCesgDataProps,
} from '../types';
import { useProjectOrganisationCesgMutation } from './useProjectOrganisationCesgMutation';

const props = defineProps<ProjectOrganisationCesgDataProps>();

const mutation = useProjectOrganisationCesgMutation({
  projectId: props.projectId,
  organisationId: props.organisationId,
});

const isReadOnly = computed(() => {
  const user = entraAuthService.me.value;
  if (!user) return true;
  return !(
    user.role === UserRole.ADMIN ||
    (user.role === UserRole.CESG &&
      hasPermission(
        props.projectId,
        [
          {
            resource: PermissionResource.OVERVIEW,
            permission: PermissionType.EDIT,
          },
        ],
        user,
      ))
  );
});

const handleAction = (event: ProjectOrganisationCesgActionEvent) => {
  if (event.type === 'save') {
    mutation.mutate({
      body: event.data.stakeholders.map((s, index) => ({
        ...s,
        order: index,
      })),
    });
  }
};

const viewProps = computed(() => ({
  name: props.name,
  stakeholders: props.stakeholders,
  isSaving: mutation.isPending.value,
  isReadOnly: isReadOnly.value,
}));
</script>

<template>
  <ProjectOrganisationCesg v-bind="viewProps" @action="handleAction" />
</template>
